<template>
  <div>
    <p class="empty-note" style="margin-bottom: 12px">
      <strong>Fushata</strong> është kontejneri (emër, kod, imazh). <strong>Ofertat</strong> krijohen me wizard: orari → rregulla → parashikim → publikim.
    </p>

    <div class="panel-card">
      <div class="section-title section-title-row">
        <span>Fushat</span>
        <button type="button" class="button is-small is-primary offer-new-btn" @click="po.createNewFushat" title="Krijo fushatë të re">
          <i class="fa fa-plus"></i>
          <span class="offer-new-btn-label">Fushatë e re</span>
        </button>
      </div>

      <div class="offer-picker-block">
        <div class="offer-picker-label">Ngarko fushatë</div>
        <div class="quick-actions offer-picker-row">
          <select v-model="po.selectedFushatGuid" class="input-clean offer-campaign-select">
            <option value="">{{ po.offerCampaignPickerEmptyLabel }}</option>
            <option v-for="item in po.offerCampaignPickerList" :key="item.guid" :value="item.guid">
              {{ item.code }} — {{ item.name }} ({{ (item.oferta || []).length }} oferta)
            </option>
          </select>
          <button type="button" class="button is-small" @click="po.loadSelectedFushat" :disabled="!po.selectedFushatGuid || po.offerFushatLoading">
            {{ po.offerFushatLoading ? "Duke ngarkuar..." : "Ngarko" }}
          </button>
          <button type="button" class="button is-small is-info is-light" :disabled="!po.offerFushatGuid" @click="po.openOfferFushatModal">
            <i class="fa fa-pencil"></i>
            <span class="offer-picker-open-btn-label">Ndrysho fushatën</span>
          </button>
          <button type="button" class="button is-small is-danger is-light" :disabled="!po.offerFushatGuid || po.offerFushatDeleteLoading" @click="po.requestDeleteLoadedFushat">
            {{ po.offerFushatDeleteLoading ? "Duke fshirë..." : "Fshi fushatën" }}
          </button>
          <button type="button" class="button is-small is-primary" :disabled="!po.offerFushatGuid || po.offerCreateOfertaLoading" @click="po.createNewOferta">
            {{ po.offerCreateOfertaLoading ? "Duke krijuar..." : "Ofertë e re" }}
          </button>
        </div>

        <p v-if="po.offerFushatGuid" class="empty-note" style="margin-top: 8px">
          <strong>Fushata aktuale:</strong> {{ po.offerFushatForm.code }} — {{ po.offerFushatForm.name }}
          <span class="chip muted" style="margin-left: 8px">{{ po.ofertaForLoadedFushat.length }} oferta</span>
        </p>
      </div>

      <div v-if="po.offerFushatGuid" class="offer-picker-block">
        <div class="offer-picker-label">Ngarko ofertë</div>
        <div class="mode-switch offer-picker-tabs" style="margin-bottom: 10px">
          <button type="button" class="mode-btn" :class="{ active: po.offerOfertaListKind === 'draft' }" @click="po.setOfferOfertaListKind('draft')">Drafte</button>
          <button type="button" class="mode-btn" :class="{ active: po.offerOfertaListKind === 'live' }" @click="po.setOfferOfertaListKind('live')">Aktive / ne pritje</button>
          <button type="button" class="mode-btn" :class="{ active: po.offerOfertaListKind === 'completed' }" @click="po.setOfferOfertaListKind('completed')">Te mbaruara / anuluar</button>
        </div>
        <div class="quick-actions offer-picker-row">
          <select v-model="po.selectedOfferGuid" class="input-clean offer-campaign-select">
            <option value="">{{ po.offerOfertaPickerEmptyLabel }}</option>
            <option v-for="item in po.offerOfertaPickerList" :key="item.guid" :value="item.guid">
              {{ item.label || "Oferta" }} — {{ po.formatTimelinePeriod(item.start_at, item.end_at)
              }}{{ po.offerOfertaListKind !== "draft" ? " (" + po.offerStatusLabel(po.effectiveOfferCampaignStatus(item)) + ")" : "" }}
            </option>
          </select>
          <button type="button" class="button is-small" @click="loadOffer" :disabled="!po.selectedOfferGuid || po.offerDraftLoading">
            {{ po.offerDraftLoading ? "Duke ngarkuar..." : "Hap ofertën" }}
          </button>
          <button type="button" class="button is-small is-danger is-light" :disabled="!po.canDeleteSelectedOffer || po.offerDeleteLoading" @click="po.requestDeleteSelectedOfferDraft">
            {{ po.offerDeleteLoading ? "Duke fshirë..." : "Fshi draft" }}
          </button>
        </div>
      </div>
    </div>

    <div class="panel-card">
      <div class="section-title">Kalendari i ofertave</div>
      <div class="quick-actions">
        <input v-model="po.offerTimelineFilter.from" class="input-clean" type="date" />
        <input v-model="po.offerTimelineFilter.to" class="input-clean" type="date" />
        <button type="button" class="button is-small" @click="po.loadOfferTimeline">Rifresko timeline</button>
        <button type="button" class="button is-small is-light" @click="po.resetTimelineToCurrentMonthAndReload">Muaji aktual</button>
      </div>
      <div class="timeline-wrap" v-if="po.offerTimeline.length && po.offerTimelineDays.length">
        <div class="timeline-header">
          <div class="timeline-title-cell">Fushata</div>
          <div class="timeline-days" :style="{ gridTemplateColumns: `repeat(${po.offerTimelineDays.length}, minmax(32px, 1fr))` }">
            <div
              v-for="d in po.offerTimelineDays"
              :key="`fush-d-${d.key}`"
              class="timeline-day-cell"
              :class="{ weekend: d.isWeekend, 'week-start': d.isWeekStart }"
            >
              <div class="timeline-day-num">{{ d.day }}</div>
              <div class="timeline-day-mon">{{ d.month }}</div>
            </div>
          </div>
        </div>
        <div class="timeline-months" :style="{ gridTemplateColumns: `repeat(${po.offerTimelineDays.length}, minmax(32px, 1fr))` }">
          <div
            v-for="m in po.offerTimelineMonths"
            :key="`fush-m-${m.key}`"
            class="timeline-month-cell"
            :style="{ gridColumnStart: m.start, gridColumnEnd: m.end }"
          >
            {{ m.label }}
          </div>
        </div>
        <div class="timeline-row" v-for="group in po.offerTimelineGroupedRows" :key="`fush-group-${group.key}`">
          <div class="timeline-label">
            <div class="timeline-name">{{ group.fushat_code }} - {{ group.fushat_name }}</div>
            <div class="timeline-meta"><span class="chip muted">{{ group.bars.length }} oferta</span></div>
          </div>
          <div class="timeline-grid" :style="{ gridTemplateColumns: `repeat(${po.offerTimelineDays.length}, minmax(32px, 1fr))` }">
            <div
              v-for="d in po.offerTimelineDays"
              :key="`fush-g-${group.key}-${d.key}`"
              class="timeline-grid-cell"
              :class="{ weekend: d.isWeekend, 'week-start': d.isWeekStart }"
            ></div>
            <div
              v-for="row in group.bars"
              :key="`bar-${row.guid}`"
              class="timeline-bar"
              :class="[`status-${row.status}`, { 'is-draggable': po.canDragTimelineBar(row) }]"
              :style="{ gridColumnStart: row.barStart, gridColumnEnd: row.barEnd }"
              @mousedown.stop.prevent="po.startTimelineDrag($event, row, 'move')"
              @click.stop="po.onTimelineBarClick(row.guid)"
              :title="`${row.displayLabel} | ${po.formatTimelinePeriod(row.start_at, row.end_at)}`"
            >
              <span
                v-if="po.canDragTimelineBar(row)"
                class="timeline-resize left"
                @mousedown.stop.prevent="po.startTimelineDrag($event, row, 'left')"
              ></span>
              {{ row.displayLabel }}
              <span
                v-if="po.canDragTimelineBar(row)"
                class="timeline-resize right"
                @mousedown.stop.prevent="po.startTimelineDrag($event, row, 'right')"
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="empty-state">Nuk ka oferta ne intervalin e zgjedhur.</div>
    </div>

    <SistemiPanel />
  </div>
</template>

<script>
import SistemiPanel from "./SistemiPanel.vue";

export default {
  name: "FushatHub",
  components: { SistemiPanel },
  inject: ["po"],
  methods: {
    async loadOffer() {
      await this.po.loadSelectedOfferDraft();
    },
  },
};
</script>
